import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <title>Page Not Found - DEKO</title>
      <meta name="description" content="The page you're looking for doesn't exist. Return to DEKO homepage for industrial packaging solutions." />
      <meta name="robots" content="noindex, nofollow" />
    
      <div className="not-found-container">
        <div className="container">
          <div className="not-found-content">
            <div className="error-code">404</div>
            <h1>Page Not Found</h1>
            <p>
              Sorry, the page you're looking for doesn't exist. 
              It might have been moved, deleted, or you entered the wrong URL.
            </p>
            <div className="not-found-actions">
              <Link to="/" className="btn btn-primary">
                Go to Homepage
              </Link>
              <Link to="/products" className="btn btn-secondary">
                View Products
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;